<!-- Transaction History Table -->
<div class="card shadow-sm">
  <!-- <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Enterprise Trips</h5>
  </div> -->

  <div
  class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
>
  <h5 class="mb-0">Enterprise Trips</h5>

  <div>
    <button
      class="btn btn-light btn-sm me-2"
      (click)="exportCurrentToExcel()"
    >
      Export Current
    </button>

    <button
      class="btn btn-warning btn-sm"
      (click)="exportAllToExcel()"
    >
      Export All
    </button>
  </div>
</div>


  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-bordered table-hover mb-0">
        <thead>
          <tr>
            <th>Trip Code</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Distance</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of trips">
            <!-- Trip Code -->
            <td class="fw-bold">{{ data.tripCode }}</td>

            <!-- Enterprise Name -->
            <td>{{ data.enterpriseDetails?.email }}</td>

            <!-- Enterprise Contact -->
            <td>{{ data.enterpriseDetails?.phone }}</td>

            <!-- Distance -->
            <td>{{ data.totalDistance }} km</td>

            <!-- Amount -->
            <td>₹ {{ data.estimatedCost?.data?.discountedTripFare }}</td>

            <!-- Status -->
            <td>
              <span
                class="badge"
                [ngClass]="{
                  'bg-warning': data.status === 1,
                  'bg-success': data.status === 2 || data.status === 3,
                  'bg-primary': data.status === 4,
                  'bg-danger': data.status === 5 || data.status === 6
                }"
              >
                {{ statusMap[data.status] }}
              </span>
            </td>

            <!-- Action -->
            <!-- <td class="text-center">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="viewTrip(data)"
              >
                <i class="fa fa-eye"></i>
              </button>
            </td> -->

            <td class="text-center">
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-outline-primary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Actions
                </button>

                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <button class="dropdown-item" (click)="viewTrip(data)">
                      <i class="fa fa-eye me-2"></i> View Trip
                    </button>
                  </li>

                  <li>
                    <button class="dropdown-item" (click)="trackTrip(data)">
                      <i class="fa fa-map-marker me-2"></i> Track Trip
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>

          <tr *ngIf="trips?.length === 0">
            <td colspan="8" class="text-center text-danger">Data not found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalRecords"
      [(page)]="page"
      [pageSize]="limit"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>
